export default "__VITE_ASSET__SMbrRYNh__"